import React, { Component } from 'react'

import { HiOutlineArrowRight } from 'react-icons/hi';

import './style.css'

export class ContactUs extends Component {
   render() {
      return (
         <div className='contact_us--component'>
            <div className="contact--box _container">
               <h3>Wanna join the interno?</h3>
               <h4>Contact Us & Get a Free Consultation</h4>
               <button className='btn_contact'>
                  <span>Connect With us</span>
                  <span className='contact_arrow-icon'><HiOutlineArrowRight /></span>
               </button>
            </div>
         </div>
      )
   }
}

export default ContactUs
